import React, { useState, useMemo, useRef, useEffect } from 'react';
import '../../aiEdit.scss'
import './changeColor.scss'
import { message, Dropdown, Slider, Divider, Tooltip, Button, Spin } from 'antd';
import Utils from '@utils/utilsEdit'
import Utils2 from '@utils/utils'
import { useLocation } from "react-router-dom";
import API, { commonApiInvoker } from '@api/api'
import axios from 'axios'
import ImgComparer from '../imgComparer'
import DragAndScale from '../dragAndScale/dragAndScale'
import ChangeColorCanvas from './changeColorCanvas';
import ToolBoxNew from '../toolBoxNew/toolBoxNew';
import { forwardRef, useImperativeHandle } from 'react'
import { AppContext } from '@utils/AppContext';
import { useContext } from 'react'
import { AIEditContext } from '../../AIEditContext';
import eventBus from '@utils/eventBus';
import { multiSemantic } from '@utils/workflowOfPrediction'
import { tasksInpaintBuild, gettasksInpaintResult } from '@utils/workflowOfBuildEdit'
import { AIEDIT_SOURCE } from '@utils/CONST';


const ChangeColor = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        onChange: () => {
            return currentImgRef.current || props.url
        },
        handleDraw,
        repairSizeChange,
        createClick,
        resetClick
    }))

    const { needPay, setNeedPay, getImgWithWatermark, eraserSize, setEraserSize, setOperationKey, setIsLoading2,
        undoList, setUndoList, redoList, setRedoList, drawType, setMultiMasks, setPaintSize, setModeState,
        isDraw, setIsDraw, aiTaskId, setReplaceorignPicLoading } = useContext(AIEditContext)
    const { aiEditDownloadWithLoadingFunc } = useContext(AppContext) // 触发更新flag

    const isMounted = useRef(true) // 判断组件是否已销毁
    const drawRef = useRef(null);
    const wrapRef = useRef()
    // const [operationKey, setOperationKey] = useState('eraser');
    const [repairSize, setrepairSize] = useState(50);
    // const [eraserSize, setEraserSize] = useState(50);
    const [urlBg, setUrlBg] = useState();
    const [orignPicBase64, setOrignPicBase64] = useState()
    const [orignPic, setOrignPic] = useState();
    const [isLoading1, setIsLoading1] = useState(false);
    const [compareBtn, setCompareBtn] = useState(false);
    const currentImgRef = useRef()
    const [currentImg, setCurrentImg] = useState('');
    const [currentImgWithWatermark, setCurrentImgWithWatermark] = useState('')
    const [reswidth, setWidth] = useState();
    const [resheight, setHeight] = useState()
    const [displayScale, setDisplayScale] = useState(1)
    const imgWidthRef = useRef()
    const [imgWidth, setImgWidth] = useState() // 图片原始宽度
    const imgHeightRef = useRef()
    const [imgHeight, setImgHeight] = useState() // 图片原始高度
    const [downloading, setDownloading] = useState();
    const [redoDataArrLength, setRedoDataArrLength] = useState(0); // 用于恢复撤销
    const location = useLocation();
    const [windowSize, setWindowSize] = useState()
    const [fabricInstance, setFabricInstance] = useState()
    const [bgInstance, setBgInstance] = useState()
    const [topInstance, setTopInstance] = useState()
    const [resizeImgInfo, setResizeImgInfo] = useState()
    const redoDataArrRef = useRef([])
    const [inited, setInited] = useState(false)
    const [changeColorRes, setChangeColorRes] = useState()
    const dragScaleRef = useRef()

    const calcCanvasSize = () => {
        const containerWidth = wrapRef.current?.clientWidth - 120 - 150
        const containerHeight = wrapRef.current?.clientHeight
        const size = Utils.getImgMaxSizeInContainer(
            imgWidthRef.current,
            imgHeightRef.current,
            containerWidth,
            containerHeight
        )
        setDisplayScale(size.width / imgWidthRef.current)
        setWidth(size.width)
        setHeight(size.height)
    }

    useEffect(() => {
        const onWindowResize = (e) => {
            calcCanvasSize()
        }
        window.addEventListener('resize', onWindowResize)
        return () => {
            isMounted.current = false
            window.removeEventListener('resize', onWindowResize)
        }
    }, [])

    useEffect(() => {
        if (!props.url) return
        resizeImage()
    }, [props.url])

    const resizeImage = async () => { // resize超过4096的图
        const resizeInfo = await Utils.resizeImageUrlMaxByAliyun(props.url, 4096)
        // console.log('resizeInfo', resizeInfo)
        setResizeImgInfo(resizeInfo)
    }

    const [ctrlKeyPressed, setCtrlKeyPressed] = useState(false)
    const ctrlKeyPressedRef = useRef(false)
    const keyZPressedRef = useRef(false)
    useEffect(() => {
        const keydown = ev => {
            if ((ev.key == 'Control' || ev.code == 'ControlLeft' || ev.code == 'ControlRight' || ev.keyCode == 17) && !ctrlKeyPressedRef.current) { // ctrl+Z 可撤销操作
                ctrlKeyPressedRef.current = true
                setCtrlKeyPressed(true)
                if (keyZPressedRef.current) {
                    // revoke()
                }
            }
            if ((ev.key == 'z' || ev.code == 'KeyZ' || ev.keyCode == 90) && !keyZPressedRef.current) { // ctrl+Z 可撤销操作
                keyZPressedRef.current = true
                if (ctrlKeyPressedRef.current) {
                    // revoke()
                }
            }
        }
        const keyup = ev => {
            if (ev.key == 'Control' || ev.code == 'ControlLeft' || ev.code == 'ControlRight' || ev.keyCode == 17) {
                ctrlKeyPressedRef.current = false
                setCtrlKeyPressed(false)
            }
            if (ev.key == 'z' || ev.code == 'KeyZ' || ev.keyCode == 90) {
                keyZPressedRef.current = false
            }
        }
        // 监听键盘按下
        document.addEventListener('keydown', keydown)
        document.addEventListener('keyup', keyup)
        return () => {
            document.removeEventListener('keydown', keydown)
            document.removeEventListener('keyup', keyup)
        }
    }, [])

    // 保存多语义分割结果
    const updateTasksMask = (output) => {
        commonApiInvoker(API.updateTasksMask(aiTaskId, {
            taskId: aiTaskId,
            mask: { 'output': output },
        }), false, true).then((res) => {
        })
    }

    // 保存结果栏的分割及服装变化
    // const updateResultMask = (output) => {
    //     commonApiInvoker(API.updateResultMask(aiTaskId, {
    //         resultId: resultId,
    //         mask: { 'output': output },
    //     }), false, true).then((res) => {
    //     })
    // }
    // const updateResultMask2 = (cloth) => {
    //     commonApiInvoker(API.updateResultMask(aiTaskId, {
    //         resultId: resultId,
    //         cloth: cloth,
    //     }), false, true).then((res) => {
    //     })
    // }


    // 多语义分割结果处理
    const changeColormultiSemantic = async (output) => {

        const resList = await Promise.all(
            output?.map(item =>
                Utils.convertImgColor(
                    item.image_path,
                    [[0, 0, 0, 255], [0, 0, 0, 0]],
                    [[255, 255, 255, 255], [30, 144, 255, 204]]
                )
            )
        );

        output.forEach((item, index) => {
            item.image_path_base64 = resList[index];
        });
        return output
    }

    // 初始化原始url
    useEffect(() => {
        if (!resizeImgInfo) return
        setReplaceorignPicLoading(true)
        const fetchData = async () => {
            if (props.outputMask && Object.keys(props.outputMask).length > 0) {
                let output = []
                output = await changeColormultiSemantic([...props.outputMask])

                setMultiMasks(output);
            } else {
                // 多语义分割
                const multiRes = await multiSemantic(resizeImgInfo?.url, () => !isMounted.current);
                if (multiRes && multiRes.output.length !== 0) {
                    const outputCopy = JSON.parse(JSON.stringify(multiRes.output))
                    const output = await changeColormultiSemantic(outputCopy)
                    setMultiMasks(output);
                    // if (props.eidtType == 'edit') {
                    //     updateResultMask([...multiRes.output]) // 保存再次编辑分割结果
                    // } else {
                    //     updateTasksMask([...multiRes.output]) // 保存左侧任务栏分割结果
                    // }
                } else {
                    // message.error('多语义分割错误！');
                }
            }

            // 分割成功后开始加载画布准备
            const base64 = await Utils.urlToBase64(resizeImgInfo?.url);
            setOrignPicBase64(base64);
            setOrignPic(resizeImgInfo?.url);
        };
        fetchData();
    }, [resizeImgInfo]);

    // 初始化画布
    useEffect(() => {
        if (!orignPic) return
        Utils.getImageDimensions(orignPic).then(({ width, height }) => {
            imgWidthRef.current = width
            imgHeightRef.current = height
            setImgWidth(width)
            setImgHeight(height)
            calcCanvasSize()
            setInited(true)
            setReplaceorignPicLoading(false)
        })
    }, [orignPic])

    useEffect(() => {
        redoDataArrRef.current = []
        setRedoDataArrLength(0)
        setIsDraw([])
        clear()
    }, [orignPic])

    const createClick = async (obj) => {
        const { selectedColor, createNum } = obj
        if (!drawRef.current) {
            message.warning('请先返回重新涂抹需要擦除的区域！', 5)
            return
        }
        if (undoList.length <= 1) {
            message.warning('请选择要更换颜色的商品区域！')
            return
        }
        setIsLoading2(true)

        // 保存颜色
        const colorHistory = JSON.parse(sessionStorage.getItem('AIEditColorList') || '[]')
        const filteredHistory = colorHistory.filter(color => color !== selectedColor)
        filteredHistory.unshift(selectedColor)
        if (filteredHistory.length > 10) {
            filteredHistory.length = 10
        }
        sessionStorage.setItem('AIEditColorList', JSON.stringify(filteredHistory))


        const resizeImg = await Utils.resizeImage(drawRef.current.getDataURL(), imgWidthRef.current, imgHeightRef.current)
        const maskResult = await Utils.convertTransparentToBlackNonTransparentToWhite(resizeImg)
        const resizeBase64Image = await Utils.resizeBase64Image(maskResult, resizeImgInfo?.originalWidth, resizeImgInfo?.originalHeight)
        const file = Utils.convertBase64ToFile(resizeBase64Image, '1.png')
        const mask = await Utils2.uploadFile(file)

        const inpaitID = await tasksInpaintBuild({
            img: currentImgRef.current || props.url,
            mask: mask,
            color: selectedColor
        }, () => !isMounted.current)
        if (inpaitID) {
            let changeColorRes;
            try {
                changeColorRes = await gettasksInpaintResult(inpaitID, () => !isMounted.current);
                message.success('处理成功！')
                currentImgRef.current = changeColorRes
                setCurrentImg(changeColorRes)
                setOrignPic(changeColorRes)
                downloadUrl.current = null
                setChangeColorRes(changeColorRes)
            } catch (error) {
                return;
            }
        }

        setIsLoading2(false)
    }

    const repairSizeChange = (value, key) => {
        setModeState(key)
        if (key == 'paint') {
            setPaintSize(value)
        } else if (key == 'eraser') {
            setEraserSize(value)
        }
    }

    const handleDraw = (key) => {
        setOperationKey(key)
        clear()
        redoDataArrRef.current = []
        setRedoDataArrLength(0)
        setIsDraw([])
    }

    useEffect(() => {
        setIsDraw([...undoList])
        setRedoDataArrLength([...redoList])
    }, [undoList, redoList])


    const undo = () => {
        if (!drawRef.current) return
        drawRef.current.undo()
        setRedoDataArrLength(redoList.length)
    }
    const redo = () => {
        if (!drawRef.current) return
        drawRef.current.redo()
    }

    const clear = () => {
        if (!drawRef.current) return
        drawRef.current.clear()
    }

    const resetClick = () => {
        if (!drawRef.current) return
        setCompareBtn(false)
        currentImgRef.current = null
        setCurrentImg()
        setOrignPic(resizeImgInfo?.url)
        dragScaleRef.current.resetCanvas()
        setRedoList([])
        setUndoList([undoList[0]]) // 保留空白画布
        drawRef.current.clear()
    }
    useEffect(() => { // 切换选区重置大小及位置
        if (drawType !== 'draw' && dragScaleRef.current) {
            dragScaleRef.current.resetCanvas()
        }
    }, [drawType, dragScaleRef.current])

    const compareClick = () => {
        if (!compareBtn) {
            getImgWithWatermark(currentImg).then(base64 => {
                setCurrentImgWithWatermark(base64)
                setCompareBtn(true)
            })
        } else {
            setCompareBtn(false)
        }
    }

    const getIsDraw = (lineArr) => {
        setIsDraw(lineArr)
    }

    const [moveable, setMoveable] = useState()
    const onDragAndScaleChange = ({ moveable }) => {
        setMoveable(moveable)
    }

    const downloadUrl = useRef()
    async function commonDownloadFunc() {
        // 需要登录
        const status = Utils2.checkLoginStatus(() => commonDownloadFunc())
        if (!status) return

        if (downloadUrl.current) {
            Utils2.downUrl(downloadUrl.current, sessionStorage.getItem('oplog_imageType'), false)
            message.success('下载成功')
        } else {
            downloadUrl.current = await aiEditDownloadWithLoadingFunc(
                currentImg,
                AIEDIT_SOURCE.COMMODITYRECOLOR,
                sessionStorage.getItem('oplog_imageType'),
                needPay
            )
            if (downloadUrl.current) setNeedPay(false)
        }
    }

    const rightContent = (
        <div className='edit_right_c' style={{ position: 'relative' }} ref={wrapRef}>
            {
                inited ?
                    <>
                        <div className='wrap_box wrap_box_'>
                            <div className='dragAndScale_box'>
                                <DragAndScale
                                    ref={dragScaleRef}
                                    zoomAllowed={!ctrlKeyPressed}
                                    min={1}
                                    max={8}
                                    onChange={onDragAndScaleChange}
                                    canvasList={[fabricInstance, bgInstance, topInstance]}
                                    disabled={compareBtn || drawType !== 'draw' ? true : false}
                                    drawType={drawType}
                                    options={[
                                        { label: '适应屏幕', value: 1 },
                                        { label: '100%', value: 1 },
                                        { label: '200%', value: 2 },
                                        { label: '300%', value: 3 },
                                        { label: '400%', value: 4 },
                                    ]}
                                />
                                {/* {compareBtn ? <p>对比时可直接使用滚轮缩放、按住鼠标移动</p> : null} */}
                            </div>
                            {
                                compareBtn &&
                                <div style={{ height: resheight, width: reswidth }} >
                                    <ImgComparer
                                        leftImage={props.url}
                                        rightImage={currentImgWithWatermark}
                                    />
                                </div>
                            }
                            <div
                                style={{
                                    position: compareBtn ? 'absolute' : 'relative',
                                    top: compareBtn ? '-9999px' : '0',
                                    left: compareBtn ? '-9999px' : '0',
                                    height: resheight - 50,
                                    width: reswidth
                                }}
                            >
                                <ChangeColorCanvas
                                    ref={drawRef}
                                    size={eraserSize}
                                    url={orignPic}
                                    moveable={moveable}
                                    displayScale={displayScale}
                                    displayWidth={reswidth}
                                    displayHeight={resheight}
                                    ctrlKeyPressed={ctrlKeyPressed}
                                    // blueMaskBase64={props.blueMaskBase64}
                                    setFabricInstance={(a, b, c) => { setBgInstance(a); setFabricInstance(b); setTopInstance(c) }}
                                    getIsDraw={getIsDraw}
                                    changeBrushSize={offset => setEraserSize(pre => pre + offset)}
                                />
                            </div>
                        </div>
                    </>
                    :
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <Spin size="large" />
                    </div>
            }
        </div>
    )

    return (
        <div className='edit_cont changeColor'>
            {
                resizeImgInfo?.url ? <ToolBoxNew
                    title='在图片上点选您需要换色的区域'
                    showCompare={compareBtn}
                    compare={{ disabled: !currentImg, trigger: compareClick }}
                    revoke={{ disabled: isDraw.length <= 1, trigger: undo }}
                    restore={{ disabled: redoDataArrLength == 0, trigger: redo }}
                    reset={{ disabled: undoList.length <= 1 && redoList.length <= 0, trigger: resetClick }}
                    download={{ disabled: !currentImg, trigger: commonDownloadFunc }}
                    uploadCb={props.uploadCb}
                /> : null
            }

            <div className='edit_right' style={{ borderRadius: `${resizeImgInfo?.url ? '0 0 16px 16px' : '16px'}` }}>
                {
                    !resizeImgInfo?.url ?
                        props.defaultPage :
                        rightContent
                }
            </div>
        </div>
    )
})

export default ChangeColor;